import sessionApi from '@/api/session'

const session={
  state:{
    application:null,
    user:null,
    tenant:null 
  },
  mutations:{
    setApplication:(state,application)=>{
      state.application=application
    },
    setUser:(state,user)=>{
      state.user=user
    },
    setTenant:(state,tenant)=>{
      state.tenant=tenant
    }
  },
  actions:{
    init({commit}){
      sessionApi.init().then(res=>{
        commit('setApplication',res.result.application)
        commit('setUser',res.result.user)
        commit('setTenant',res.result.tenant)
      })
    }
  }
}
export default session